// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerWrapper__bSHb-{
    display:flex;
    justify-content: flex-start;
    /* flex-direction:column; */
    align-items:center;
    flex-wrap:wrap;
    /* width:40vw; */
    width:100%;
    height:100%;
    /* padding:10px; */


}
.styles_header__oWNMk{
  display:flex;
  box-sizing: border-box;
  justify-content: center;
  align-items:center;
  width:100%;
  height:auto;
  padding:16px;
}
.styles_container__LJ0T5{
    display:flex;
    justify-content: flex-start;
    flex-direction:column;
    align-items:flex-start;
    /* flex-wrap:wrap; */
    width:100%;
    height:auto;
    padding:10px;
    max-height:250px;
    overflow:auto;

    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_container__LJ0T5::-webkit-scrollbar {
  
    background: transparent;
    width: 8px;
  }
  .styles_userText__DoEhH{
    margin:0 5px;
  }
  .styles_container__LJ0T5::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_container__LJ0T5.styles_dark__J9Jn6{
    scrollbar-color: #555555 transparent;
    scrollbar-width: 8px;
  }
.styles_container__LJ0T5>div, .styles_container__LJ0T5.styles_dark__J9Jn6>div{
    /* width:20vw; */
    width:100%;
    padding:10px;
}
.styles_button__oanex{
  width:calc( 100% - 20px);
  border-radius:4px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ShareUsersContent/styles.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,kBAAkB;;;AAGtB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;;IAEb,oCAAoC;IACpC,oBAAoB;EACtB;EACA;;IAEE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,oCAAoC;IACpC,oBAAoB;EACtB;AACF;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB","sourcesContent":[".containerWrapper{\n    display:flex;\n    justify-content: flex-start;\n    /* flex-direction:column; */\n    align-items:center;\n    flex-wrap:wrap;\n    /* width:40vw; */\n    width:100%;\n    height:100%;\n    /* padding:10px; */\n\n\n}\n.header{\n  display:flex;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items:center;\n  width:100%;\n  height:auto;\n  padding:16px;\n}\n.container{\n    display:flex;\n    justify-content: flex-start;\n    flex-direction:column;\n    align-items:flex-start;\n    /* flex-wrap:wrap; */\n    width:100%;\n    height:auto;\n    padding:10px;\n    max-height:250px;\n    overflow:auto;\n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n  .container::-webkit-scrollbar {\n  \n    background: transparent;\n    width: 8px;\n  }\n  .userText{\n    margin:0 5px;\n  }\n  .container::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n  .container.dark{\n    scrollbar-color: #555555 transparent;\n    scrollbar-width: 8px;\n  }\n.container>div, .container.dark>div{\n    /* width:20vw; */\n    width:100%;\n    padding:10px;\n}\n.button{\n  width:calc( 100% - 20px);\n  border-radius:4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWrapper": `styles_containerWrapper__bSHb-`,
	"header": `styles_header__oWNMk`,
	"container": `styles_container__LJ0T5`,
	"userText": `styles_userText__DoEhH`,
	"dark": `styles_dark__J9Jn6`,
	"button": `styles_button__oanex`
};
export default ___CSS_LOADER_EXPORT___;
